import { useDisableNativeTokenSelling } from '../hooks/useDisableNativeTokenSelling'

// TODO: Add proper return type annotation
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function DisableNativeTokenSellingUpdater() {
  useDisableNativeTokenSelling()
  return null
}
